import type { SharedAnswerExample } from '../services/share';

declare global {
  interface Window {
    __PALEN_LANDING_EXAMPLES__?: SharedAnswerExample[];
  }
}

export function readPrerenderedSharedAnswerExamples(): SharedAnswerExample[] {
  if (typeof window === 'undefined' || !Array.isArray(window.__PALEN_LANDING_EXAMPLES__)) {
    return [];
  }

  return window.__PALEN_LANDING_EXAMPLES__;
}
